import React, { useEffect, useState, useRef } from "react";
import MainLayout from "../nav/MainLayout";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import LandingPage from "../Layout/UnitAdmin/LandingPage";
import SuperAdminLanding from "../Layout/SuperAdmin/LandingScreen.jsx";
import { getToken } from "../auth/authConfig.js";
import iconLoading from "../../assets/img/Loader5.gif";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useMsal,
} from "@azure/msal-react";
import Login from "../auth/Login.jsx";
import Footer from "../reusables/Footer.jsx";
import MarsAdmin from "../Layout/MarsVerifications/MarsAdmin.jsx";
import LeadAuditorLandingPage from "../Layout/AuditAdmin/LeadAuditorLandingPage.jsx";
import Error401 from "../reusables/Error401.jsx";
import Error403 from "../reusables/Error403.jsx";
import Error500 from "../reusables/Error500.jsx";
import Error404 from "../reusables/Error404.jsx";
import TechReviewerHome from "../Layout/TechReviewer/TechReviewerHome.jsx";

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  padding: theme.spacing(2, 0),
  ...theme.mixins.toolbar,
}));

export default function Home() {
  const [loading, setloading] = useState(false);
  const [error, seterror] = useState(false);
  const [errorCode, seterrorCode] = useState();

  const [userinfo, setuserinfo] = useState({});
  const [pageDetails, setPageDetails] = useState();

  const getUserinfo = async () => {
    const maxRetries = 3;
    const url = `${process.env.REACT_APP_SERVER_URL}/api/user/getUserInfoV2`;
    const token = await getToken();
    setloading(true);
  
    for (let attempt = 1; attempt <= maxRetries; attempt++) {
      try {
        const response = await fetch(url, {
          headers: {
            "oidc-token": token,
            Accept: "application/json",
          },
        });
  
        if (response.status === 200) {
          const json = await response.json();
          setloading(false);
          setuserinfo(json?.user);
          const info = json?.user;
          const role = info?.group_name;
          const company = info?.company;
  
          setPageDetails(role);
          localStorage.setItem("GroupName", role);
          localStorage.setItem("company", company);
          return; // Successfully finished, exit function.
        }
  
        // Handle different error statuses
        else {
          setloading(false);
          seterror(true);
          seterrorCode(response.status);
          console.log(`Error: ${response.status}`);
          
          // Retry for specific status codes (e.g., 500 or network error)
          if (response.status === 500 || response.status === 503) {
            if (attempt < maxRetries) {
              console.log(`Retrying attempt ${attempt + 1}...`);
              continue; // Retry
            }
          }
  
          return; // End if non-retryable error
        }
      } catch (err) {
        console.log(`Attempt ${attempt} failed:`, err);
  
        // Retry on network errors or server issues (like 500 or 503)
        if (attempt < maxRetries) {
          console.log(`Retrying attempt ${attempt + 1}...`);
          continue; // Retry
        }
  
        setloading(false);
        seterror(true);
        seterrorCode(500); // You can use a generic error code for network issues
        return;
      }
    }
  
    // If all attempts failed, finalize
    setloading(false);
    seterror(true);
    seterrorCode(500); // Fallback error code after all retries
  };
  

  useEffect(() => {
    getUserinfo();
  }, [errorCode]);

  return (
    <>
      <AuthenticatedTemplate>
        <div id="homePage" style={{ overflow: "hidden", position: "relative" }}>
          <Box
            className="mainLayout"
            sx={{ display: "flex", overflow: "hidden" }}
          >
            <MainLayout />

            <Box component="main" sx={{ flexGrow: 1, p: 1 }}>
              <DrawerHeader />
              {/* <DrawerHeader style={{ minHeight: "0px", paddingTop: "3px" }} /> */}

              <div id="mainHome" style={{ overflowY: "auto" }}>
                {loading && (
                  <div
                    style={{
                      display: "grid",
                      alignContent: "center",
                      alignItems: "center",
                      justifyContent: "center",
                      justifyItems: "center",
                      gap: "20px",
                      height: "100%",
                    }}
                  >
                    <img src={iconLoading} width={100} alt="loading" />
                    <span style={{ fontSize: "24px" }}>
                      Please wait while loading the resources
                    </span>
                  </div>
                )}

                {!loading && !error && (
                  <>
                    {pageDetails === "Unit Admin" ? (
                      <>
                        <LandingPage />
                      </>
                    ) 
                    : pageDetails === "Super Admin" ? (
                     <>
                      <SuperAdminLanding />
                     </>
                    ) 
                    : pageDetails === "Mars Admin" ? (
                      <>
                        <MarsAdmin />
                      </>
                      
                    ) 
                    : pageDetails === "Tech Reviewer" ? (
                      <>
                        <TechReviewerHome />
                      </>
                      
                    ) 
                    : pageDetails === "CB Admin (Tech Reviewer)" ? (
                      <>
                        <TechReviewerHome />
                      </>
                      
                    )
                    : pageDetails === "Lead Auditor" ? (
                      <>
                        <LeadAuditorLandingPage />
                      </>
                    )
                    : pageDetails === "CB Admin" ? (
                      <>
                        <LeadAuditorLandingPage />
                      </>
                    ) : (
                      <> </>
                    )}
                  </>
                )}

                {!loading && error && (
                  <>
                    {errorCode === 401 ? (
                      <>
                        <Error401 />
                      </>
                    ) : errorCode === 403 ? (
                      <>
                        <Error403 />
                      </>
                    )
                      : errorCode === 404 ? (
                        <>
                          <Error404 />
                        </>
                      )
                        : (
                          <Error500 />
                        )}
                  </>
                )}
                <Footer />
              </div>
            </Box>
          </Box>
        </div>
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        <Login />
      </UnauthenticatedTemplate>
    </>
  );
}
